import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorage {
    public get<T>(key: string): T | null {
        const value = localStorage.getItem(key);

        if (value != null) {
            return JSON.parse(value) as T;
        }

        return null;
    }

    public set<T>(key: string, value: T): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public remove(key: string): void {
        localStorage.removeItem(key);
    }

    public setWithExpiry<T>(key : string, value : T, ttl : number) : void{
        const now = new Date()
    
        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        localStorage.setItem(key, JSON.stringify(item))
    }
    
    public getWithExpiry<T>(key: string) : T | null {
        const itemStr = localStorage.getItem(key)
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null
        }
        const item = JSON.parse(itemStr)
        const now = new Date()
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key)
            return null
        }
        return item.value
    }
}
